const size = {
  mobile: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopLow: '1280px',
  laptopMid: '1420px',
}

const sizeHeight = {
  mobile: '550px',
  tablet: '650px',
  laptop: '700px',
}

export const devices = {
  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopLow: `(max-width: ${size.laptopLow})`,
  laptopMid: `(max-width: ${size.laptopMid})`,
}

export const devicesHeight = {
  mobile: `(max-height: ${sizeHeight.mobile})`,
  tablet: `(max-height: ${sizeHeight.tablet}) and (min-height: ${sizeHeight.mobile})`,
  laptop: `(max-height: ${sizeHeight.laptop}) and (min-height: ${sizeHeight.tablet})`,
}